/**
 * Shared tool-icon lookup for the reasoning timeline.
 *
 * Lives in its own module so both ToolUseItem (single call) and ToolUseGroup
 * (collapsed run of identical calls) render the same icon for a given tool.
 */
import {
  BarChart04,
  Briefcase02,
  Building06,
  Calendar,
  Database01,
  Edit05,
  File06,
  FilePlus02,
  Globe02,
  LayoutAlt02,
  List,
  Mail01,
  Mail02,
  SearchLg,
  Tool02,
  User01,
  UserPlus01,
  Users01,
  VideoRecorder,
  XCircle,
} from '@untitledui/icons';
import type { ReactElement } from 'react';

/**
 * Get the appropriate icon element for a tool, keyed by the `icon` value in
 * TOOL_CONFIG. Falls back to a generic tool icon for unknown keys.
 */
export function getToolIcon(iconName: string, className: string): ReactElement {
  const iconMap: Record<string, ReactElement> = {
    search: <SearchLg className={className} strokeWidth={1.5} />,
    'mail-search': <SearchLg className={className} strokeWidth={1.5} />,
    'mail-open': <Mail02 className={className} strokeWidth={1.5} />,
    mail: <Mail01 className={className} strokeWidth={1.5} />,
    calendar: <Calendar className={className} strokeWidth={1.5} />,
    video: <VideoRecorder className={className} strokeWidth={1.5} />,
    globe: <Globe02 className={className} strokeWidth={1.5} />,
    'file-plus': <FilePlus02 className={className} strokeWidth={1.5} />,
    edit: <Edit05 className={className} strokeWidth={1.5} />,
    'x-circle': <XCircle className={className} strokeWidth={1.5} />,
    file: <File06 className={className} strokeWidth={1.5} />,
    list: <List className={className} strokeWidth={1.5} />,
    building: <Building06 className={className} strokeWidth={1.5} />,
    users: <Users01 className={className} strokeWidth={1.5} />,
    briefcase: <Briefcase02 className={className} strokeWidth={1.5} />,
    database: <Database01 className={className} strokeWidth={1.5} />,
    'edit-3': <Edit05 className={className} strokeWidth={1.5} />,
    user: <User01 className={className} strokeWidth={1.5} />,
    'user-plus': <UserPlus01 className={className} strokeWidth={1.5} />,
    'users-plus': <Users01 className={className} strokeWidth={1.5} />,
    'bar-chart': <BarChart04 className={className} strokeWidth={1.5} />,
    layout: <LayoutAlt02 className={className} strokeWidth={1.5} />,
    tool: <Tool02 className={className} strokeWidth={1.5} />,
  };

  return (
    iconMap[iconName] || <Tool02 className={className} strokeWidth={1.5} />
  );
}
